/* Copyright (c) 2020-present CloudIO Inc */

const localDevelopment = false;

const BASE_URL = localDevelopment
  ? 'http://localhost:3090/'
  : 'https://dev.cloudio.io/';

let logged = false;

export function getActualUrl() {
  let url = window.location.href;
  let index = url.indexOf('#');
  if (index !== -1) {
    url = url.substring(0, index);
  }
  index = url.lastIndexOf('/');
  if (index > 10) {
    url = url.substring(0, index);
  }
  if (url.endsWith('/a')) {
    url = url.substring(0, url.length - 2);
  }
  url = `${url}/`;
  return url;
}

export function getBaseUrl() {
  let url = BASE_URL;
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'test'
  ) {
    url = BASE_URL;
  } else {
    url = getActualUrl();

    if (url === 'http://localhost:3000/' || url === 'http://localhost:3003/') {
      url = BASE_URL;
    }
  }

  if (process.env.NODE_ENV === 'development' && !logged) {
    // eslint-disable-next-line no-console
    console.info(`[cloudio] Connecting to server: ${url}`);
    logged = true;
  }
  return url;
}

export const getUrl = () => {
  return `${getBaseUrl()}v1/`;
};

export const getOAuthUrl = () => {
  return `${getBaseUrl()}oauth`;
};

export const getOAuthSignoutUrl = () => {
  return `${getBaseUrl()}oauthsignout`;
};

export const getWSUrl = () => {
  const _url = getBaseUrl()
    .replace('https://', 'wss://')
    .replace('http://', 'ws://');
  return `${_url}ws/v1/`;
};

export function getImageUrl({
  appUid,
  url,
  width,
  height,
}: {
  appUid: string;
  url: string;
  width: number;
  height: number;
}) {
  const req = btoa(JSON.stringify({ url, width, height }));
  return `${getUrl()}ri/${appUid}/${encodeURIComponent(req)}`;
}
